import { render } from "./pcHome.vue?vue&type=template&id=64dde9ae&ts=true"
import script from "./pcHome.vue?vue&type=script&lang=ts"
export * from "./pcHome.vue?vue&type=script&lang=ts"

import exportComponent from "/home/ssh/jigoucode/jigou_fe_v5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__